export const ServiceUri = process.env.REACT_APP_SERVICE_URI;